"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateShortDate = exports.validateConfig = exports.fiscalRanges = exports.generatePeriodRanges = exports.generateRanges = exports.validateRangesRequest = void 0;
const Reports_1 = require("./Reports");
const commonUtil = __importStar(require("./commonUtil"));
const Errors_1 = require("./Errors");
function validateRangesRequest(request, name) {
    if (!request?.timeframe || request.timeframe === Reports_1.ReportTimeframes.Year_to_Date) {
        throw Errors_1.CommonErrors.unsupportedTimeframe(name, request.timeframe);
    }
    if (!request.start && !request.limit) {
        throw Errors_1.CommonErrors.requiredStartOrLimit(name);
    }
    if (request.timeframe === Reports_1.ReportTimeframes.Week && !request.weekStart) {
        throw Errors_1.CommonErrors.requiredWeekStart();
    }
    if (request.start) {
        validateShortDate(request.start, "start");
    }
    if (request.end) {
        validateShortDate(request.end, "end");
    }
}
exports.validateRangesRequest = validateRangesRequest;
function generateRanges(request) {
    if (request.configData?.periodReporting) {
        return generatePeriodRanges(request);
    }
    validateRangesRequest(request, generateRanges.name);
    // If the start is equal to or after the end, we return empty (there should be nothing to return)
    if (request.end && request.start && request.end <= request.start) {
        return [];
    }
    const toReturn = [];
    let genDate = !request.end ? new Date() : commonUtil.shiftDays(commonUtil.fromShortString(request.end), -1);
    // We keep generating while there is no limit or the limit hasn't been reached
    while (!request.limit || (request.limit && toReturn.length < request.limit)) {
        const newPeriod = range(genDate, request.timeframe, request.weekStart);
        // We stop generating if the start of the new period is before start
        // (otherwise we keep going, we want to generate a period which includes start)
        if (request.start && request.start > newPeriod.end) {
            break;
        }
        if (request.includeNames) {
            newPeriod.name = rangeName(newPeriod, request, genDate);
        }
        toReturn.push(newPeriod);
        genDate = commonUtil.shiftPeriod(genDate, request.timeframe, -1);
    }
    return toReturn;
}
exports.generateRanges = generateRanges;
function rangeName(range, request, genDate) {
    const timeframe = request.timeframe;
    if (request.timeframe === Reports_1.ReportTimeframes.Week) {
        // We use the end date of the newly generated week to compare
        // This is more accurate for weeksDifference and guaranteed to be in the right year
        const compareDate = range.endDate ?? commonUtil.fromShortString(range.end);
        let yearStart = commonUtil.fromShortString(commonUtil.yearStart(compareDate));
        if (yearStart.getDay() !== commonUtil.weekStartIndex(request.weekStart)) {
            // If Jan 1st isn't the start of the week, "Week 1" is the start of the week which contains it
            yearStart = commonUtil.weekRange(yearStart, request.weekStart).startDate;
        }
        return `W${(commonUtil.weeksDifference(compareDate, yearStart) + 1).toString().padStart(2, '0')}`;
    }
    else if (request.timeframe === Reports_1.ReportTimeframes.Month) {
        return `M${(genDate.getMonth() + 1).toString().padStart(2, '0')}`;
    }
    else if (request.timeframe === Reports_1.ReportTimeframes.Quarter) {
        return `Q${Math.ceil((genDate.getMonth() + 1) / 3)}`;
    }
    else if (request.timeframe === Reports_1.ReportTimeframes.Year) {
        return `${genDate.getFullYear()}`;
    }
    else {
        throw Errors_1.CommonErrors.unsupportedTimeframe(rangeName.name, timeframe);
    }
}
function range(d, timeframe, weekStart) {
    if (timeframe === Reports_1.ReportTimeframes.Month) {
        return commonUtil.monthRange(d);
    }
    else if (timeframe === Reports_1.ReportTimeframes.Week) {
        return commonUtil.weekRange(d, weekStart);
    }
    else if (timeframe === Reports_1.ReportTimeframes.Quarter) {
        return commonUtil.quarterRange(d);
    }
    else if (timeframe === Reports_1.ReportTimeframes.Year) {
        return commonUtil.yearRange(d);
    }
    else {
        throw Errors_1.CommonErrors.unsupportedTimeframe(range.name, timeframe);
    }
}
function validatePeriodRangesRequest(configData, request) {
    validateRangesRequest(request, generatePeriodRanges.name);
    if (!request.weekStart) {
        throw Errors_1.CommonErrors.requiredWeekStartPeriod();
    }
    validateConfig(configData);
    return request.weekStart;
}
function generatePeriodRangesWeek(configData, request) {
    validatePeriodRangesRequest(configData, request);
    const weeklyRequest = Object.assign({ ...request }, { includeNames: false, configData: undefined });
    const startingPoint = findValidStartingPoint(configData, weeklyRequest.start);
    if (!weeklyRequest.start || weeklyRequest.start < startingPoint) {
        // Need to set the starting point so we don't generate data before the startingPoint
        weeklyRequest.start = startingPoint;
    }
    const weeklyRanges = generateRanges(weeklyRequest);
    if (!request.includeNames) {
        return weeklyRanges;
    }
    const yearlyRequest = Object.assign({ ...request }, { includeNames: false, timeframe: Reports_1.ReportTimeframes.Year });
    const yearlyRanges = generatePeriodRanges(yearlyRequest);
    return weeklyRanges.map(range => {
        const year = yearlyRanges.find(year => commonUtil.insideRange(range, year.start, year.end))?.startDate;
        if (year) {
            // Using endDate should be more accurate with weeksDifference
            range.name = `W${(commonUtil.weeksDifference(range.endDate, year) + 1).toString().padStart(2, '0')}`;
        }
        return range;
    });
}
function generatePeriodRanges(request) {
    if (!request?.configData?.periodReporting) {
        return generateRanges(request);
    }
    const configData = request.configData;
    if (request?.timeframe === Reports_1.ReportTimeframes.Week) {
        return generatePeriodRangesWeek(configData, request);
    }
    const weekStart = validatePeriodRangesRequest(configData, request);
    const start = request.start;
    // If the start is equal to or after the end, we return empty (there should be nothing to return)
    if (request.end && start && request.end <= start) {
        return [];
    }
    const startingPoint = findValidStartingPoint(configData, request.start);
    let startDate = commonUtil.fromShortString(startingPoint);
    const periodToUse = request.timeframe === Reports_1.ReportTimeframes.Year ? 52 : quarterPeriod(configData);
    const endDate = request.end ? commonUtil.fromShortString(request.end) : new Date();
    const possibleRanges = [];
    let periodNumber = 1;
    while (startDate.getTime() < endDate.getTime()) {
        const is444Q4 = find444Q4(configData, periodNumber, request.timeframe);
        const generatePeriod = is444Q4 ? periodToUse + 4 : periodToUse; // 444 has an extra 4-week period at the end of Q4
        const range = commonUtil.weekRange(startDate, weekStart, generatePeriod);
        // Will automatically shift "range" if there are leap weeks, we only need to use these for "months" and the final shift
        const leapWeeks = configData.leapYearRestartDates ? shiftForLeapYears(range, generatePeriod, weekStart, configData.leapYearRestartDates) : 0;
        if (request.timeframe === Reports_1.ReportTimeframes.Month) {
            const monthEnd = request.end ?? commonUtil.toShortString(endDate);
            // 444 has an extra 4-week period at the end of Q4
            const periodConfig = is444Q4 ? [4, 4, 4, 4] : configData.periodConfiguration;
            possibleRanges.push(...breakdownMonthPeriods(range, weekStart, configData, leapWeeks, periodConfig)
                .filter(d => d.start < monthEnd)
                .map((r, i) => addFiscalName(r, 3 * (periodNumber - 1) + i + 1, request)));
        }
        else {
            possibleRanges.push(addFiscalName(range, periodNumber, request));
        }
        // Setup next step
        startDate = commonUtil.shiftNextWeek(startDate, generatePeriod + leapWeeks);
        periodNumber = (generatePeriod * periodNumber >= 52) ? 1 : periodNumber + 1; // Add 1 or reset for new year
    }
    // If start exists, filter down to ranges that start later or contain start
    // we also reverse so the latest ranges come first
    const filtered = start ? possibleRanges
        .filter((d) => d.start >= start || d.end >= start).reverse() : possibleRanges.reverse();
    // If limit exists, we only return the first limit results
    return request.limit ? filtered.slice(0, request.limit) : filtered;
}
exports.generatePeriodRanges = generatePeriodRanges;
function fiscalRanges(timeframe, weekStart, start, period, configData) {
    validateConfig(configData);
    validateShortDate(start, "start");
    if (timeframe === Reports_1.ReportTimeframes.Year_to_Date) {
        throw Errors_1.CommonErrors.unsupportedTimeframe(fiscalRanges.name, timeframe);
    }
    else if (!configData.periodReporting || period <= 0) {
        return [];
    }
    else if (timeframe === Reports_1.ReportTimeframes.Week) {
        const request = new Reports_1.GenerateRangesRequest(timeframe, weekStart, configData);
        request.limit = period;
        const startingPoint = (configData.generateStartDate && start < configData.generateStartDate) ?
            configData.generateStartDate : start;
        // If we shift "period - 1" weeks into the future (plus 1 day), then generate ranges will generate the previous "period" weeks
        request.end = commonUtil.toShortString(commonUtil.shiftDays(commonUtil.fromShortString(startingPoint), 7 * (period - 1) + 1));
        request.includeNames = false;
        return generatePeriodRanges(request).reverse();
    }
    const ranges = [];
    const startingPoint = findValidStartingPoint(configData, start);
    const periodToUse = timeframe === Reports_1.ReportTimeframes.Year ? 52 : quarterPeriod(configData);
    let startDate = commonUtil.fromShortString(startingPoint);
    let count = 0;
    let periodNumber = 1;
    while (count < period) {
        const is444Q4 = find444Q4(configData, periodNumber, timeframe);
        const generatePeriod = is444Q4 ? periodToUse + 4 : periodToUse; // 444 has an extra 4-week period at the end of Q4
        const range = commonUtil.weekRange(startDate, weekStart, generatePeriod);
        const leapWeeks = configData.leapYearRestartDates ? shiftForLeapYears(range, generatePeriod, weekStart, configData.leapYearRestartDates) : 0;
        const addRanges = count > 0 || range.end >= start;
        if (addRanges) {
            // 444 has an extra 4-week period at the end of Q4
            const periodConfig = is444Q4 ? [4, 4, 4, 4] : configData.periodConfiguration;
            const foundRanges = timeframe === Reports_1.ReportTimeframes.Month ?
                breakdownMonthPeriods(range, weekStart, configData, leapWeeks, periodConfig) :
                [range];
            if (!foundRanges.length) {
                throw new Error("Unexpected error foundRanges is empty!");
            }
            foundRanges.filter(r => r.end >= start)
                .forEach(r => {
                if (count < period) {
                    ranges.push(r);
                    count++;
                }
            });
        }
        startDate = commonUtil.shiftNextWeek(startDate, generatePeriod + leapWeeks);
        periodNumber = (generatePeriod * periodNumber >= 52) ? 1 : periodNumber + 1; // Add 1 or reset for new year
    }
    return ranges;
}
exports.fiscalRanges = fiscalRanges;
function find444Q4(configData, periodNumber, timeframe) {
    return is444(configData) && periodNumber === 4 &&
        (timeframe === Reports_1.ReportTimeframes.Month || timeframe === Reports_1.ReportTimeframes.Quarter);
}
function addFiscalName(range, periodNumber, request) {
    if (!request.includeNames) {
        return range;
    } // Do nothing
    if (request.timeframe === Reports_1.ReportTimeframes.Month) {
        range.name = `P${periodNumber.toString().padStart(2, '0')}`;
    }
    else if (request.timeframe === Reports_1.ReportTimeframes.Quarter) {
        range.name = `Q${periodNumber}`;
    }
    else if (request.timeframe === Reports_1.ReportTimeframes.Year) {
        const dateToUse = range.startDate.getMonth() === 0 ? range.startDate : range.endDate;
        range.name = `${dateToUse.getFullYear()}`;
    } // else - do nothing note that week is handled within generatePeriodWeekRangesWithNames
    return range;
}
function shiftForLeapYears(periodToShift, period, weekStart, leapYearRestartDates) {
    const compare = periodToShift.end;
    // We sort the leap year configs by date and find the first (i.e. nearest) that is greater than the start of the period
    const closestLeapYear = sortedLeapDates(leapYearRestartDates)
        .find((s) => compare.localeCompare(s) < 0);
    if (!closestLeapYear) {
        return 0;
    } //No leap year to shift - do nothing
    const leapDate = commonUtil.weekRange(commonUtil.fromShortString(closestLeapYear), weekStart).startDate;
    const compareDate = commonUtil.fromShortString(compare);
    // We floor here because we are comparing a start of a week to the start of another
    // We are also expecting that leapDate is the first date of the "next" period, so we are fine being off by 1
    const weeksDifference = commonUtil.weeksDifference(leapDate, compareDate);
    if (weeksDifference >= period) {
        return 0; // Not the period we will be shifting
    }
    // In this case, we need to make the shift by weeksDifference periods...
    periodToShift.end = commonUtil.toShortString(commonUtil.shiftNextWeek(compareDate, weeksDifference));
    return weeksDifference;
}
function breakdownMonthPeriods(quarter, weekStart, config, leapWeeks, periods) {
    if (!periods) {
        return [quarter];
    }
    let startDate = commonUtil.fromShortString(quarter.start);
    return periods.map((p, i) => {
        const numWeeks = isLeapPeriod(config, leapWeeks, periods, i) ? p + leapWeeks : p;
        const period = commonUtil.weekRange(startDate, weekStart, numWeeks);
        startDate = commonUtil.shiftNextWeek(startDate, numWeeks);
        return period;
    });
}
function isLeapPeriod(config, leapWeeks, periods, curIndex) {
    if (!leapWeeks) {
        return false;
    }
    if (config.leapWeek2ndLast) {
        return curIndex === periods.length - 2;
    }
    else {
        return curIndex === periods.length - 1;
    }
}
function quarterPeriod(configData) {
    return configData.periodConfiguration?.reduce((s, v) => s + v, 0) ?? 13;
}
function findValidStartingPoint(configData, start) {
    const startingPoint = generatePeriodRangesStartingPoint(configData, start);
    if (!startingPoint) {
        throw Error(`${startingPoint} is not a valid date`);
    }
    return startingPoint;
}
function generatePeriodRangesStartingPoint(configData, start) {
    const generateStartDate = configData.generateStartDate;
    if (!generateStartDate) {
        return start;
    }
    if (!start || start < generateStartDate || !configData.leapYearRestartDates) {
        return generateStartDate;
    }
    return closestLeapYear(configData.leapYearRestartDates, start) ?? generateStartDate;
}
function closestLeapYear(leapYearRestartDates, compareDate) {
    // We sort the leap year configs by date and find the first (i.e. nearest) that is less than compareDate
    return sortedLeapDates(leapYearRestartDates)
        .find((s) => compareDate.localeCompare(s) > 0);
}
function sortedLeapDates(leapYearRestartDates) {
    return leapYearRestartDates.sort((a, b) => a.localeCompare(b));
}
function validateConfig(config) {
    if (!config.periodReporting && (config.periodConfiguration || config.leapYearRestartDates ||
        config.generateStartDate || config.leapWeek2ndLast)) {
        throw Errors_1.ReportConfigErrors.invalidConfigNonPeriod();
    }
    if (config.periodReporting && (!config.periodConfiguration || !config.generateStartDate)) {
        throw Errors_1.ReportConfigErrors.invalidConfigPeriod();
    }
    if (config.generateStartDate) {
        validateShortDate(config.generateStartDate, "generateStartDate");
        const generateStartDate = commonUtil.fromShortString(config.generateStartDate);
        if (generateStartDate.getTime() > Date.now()) {
            throw Errors_1.ReportConfigErrors.invalidFutureGenerateStart(config.generateStartDate);
        }
    }
    if (config.periodConfiguration && !is444(config)) {
        const qp = quarterPeriod(config);
        if ((Errors_1.ReportConfigErrors.defaultWeeksInYear % qp) !== 0) {
            throw Errors_1.ReportConfigErrors.invalidQuarterPeriod(config.periodConfiguration, qp);
        }
    }
    const generateStartDate = config.generateStartDate;
    if (config.leapYearRestartDates && generateStartDate) {
        const sorted = sortedLeapDates(config.leapYearRestartDates);
        let prevDate = commonUtil.fromShortString(generateStartDate);
        sorted.forEach((date) => {
            validateShortDate(date, "leapYearRestartDate");
            if (date <= generateStartDate) {
                throw Errors_1.ReportConfigErrors.invalidLeapDateBeforeStart(date, generateStartDate);
            }
            const curDate = commonUtil.fromShortString(date);
            const diff = commonUtil.weeksDifference(curDate, prevDate);
            // Here we expect the leap date to be 1 more week than 52 weeks from prevDate
            // (either the generateStartDate or the previous leap date)
            if ((diff % Errors_1.ReportConfigErrors.defaultWeeksInYear) !== 1) {
                throw Errors_1.ReportConfigErrors.invalidLeapDate(date, diff, commonUtil.toShortString(prevDate));
            }
            prevDate = curDate;
        });
    }
    else if (config.leapWeek2ndLast) {
        throw Errors_1.ReportConfigErrors.invalidLeapWeek2ndLast();
    }
}
exports.validateConfig = validateConfig;
function is444(config) {
    return !!config.periodConfiguration && config.periodConfiguration.length === 3 &&
        config.periodConfiguration.every(pc => pc === 4);
}
function validateShortDate(shortDate, name) {
    if (!commonUtil.validShortDate(shortDate)) {
        throw Errors_1.ReportConfigErrors.invalidShortDate(shortDate, name);
    }
}
exports.validateShortDate = validateShortDate;
//# sourceMappingURL=reportUtil.js.map